const countryPickers = document.querySelectorAll('.countryPicker')

if (countryPickers) {
    countryPickers.forEach(countryPicker => {
        const countryPickerLinks = countryPicker.querySelectorAll('.disclosure__item a')
        const countryPickerCountry = countryPicker.querySelector('input[name="country_code"]')
        const countryPickerLang = countryPicker.querySelector('input[name="language_code"]')
        const form = countryPicker.querySelector('form')

        countryPickerLinks.forEach(item => {
            item.addEventListener('click', (e) => {
                e.preventDefault()
                countryPickerCountry.value = item.dataset.value
                countryPickerLang.value = item.dataset.lang
                form.submit()
            })
        })
    })
}
